<template>
    <div class="room-view text-center pb-1 mx-1 my-1">
        <div class="px-1">{{ roomDesc }}</div>
        <div class="devices d-flex justify-center">
            <device-health-icon
                v-for="device in devices"
                :key="`device-${device.id}`"
                :value="{
                    status: device.healthCheckStatus || '',
                    statusDate: device.healthCheckStatusDate || ''
                }"
                :tooltip="getDeviceTooltip(device)"
                class="px-1"
                button
                button-color="accent"
                @click="onDeviceClick(device)"
            ></device-health-icon>
        </div>
    </div>
</template>

<script>
import DeviceHealthIcon from '@/components/Fields/DeviceHealthIcon';

export default {
    name: 'RoomView',
    components: {
        'device-health-icon': DeviceHealthIcon
    },
    props: {
        building: {
            type: String,
            default: ''
        },
        wing: {
            type: String,
            default: ''
        },
        floor: {
            type: String,
            required: true
        },
        room: {
            type: [String, Number],
            required: true
        },
        devices: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    computed: {
        roomDesc() {
            return `${this.room}`;
        }
    },
    methods: {
        onDeviceClick(device) {
            this.$emit('device-click', device);
        },
        getDeviceTooltip(device) {
            let result = [];
            result.push(`Id: ${device.id}`);
            result.push(`Name: ${device.name}`);
            result.push(`Model: ${device.model}`);
            result.push(`Host Mac: ${device.hostMac}`);
            result.push(`Serial Number: ${device.serialNumber}`);
            return result;
        }
    }
};
</script>

<style lang="scss" scoped>
.room-view {
    border-radius: 5px;
    min-width: 48px;
    min-height: 56px;
}
</style>
